import React from 'react';
import { SkinPageProps } from '../SkinPage';
import Page from '../../Page';
import styles from './styles/LiftedShadowPageSkin.scss';

const LiftedShadowSkin: React.FC<SkinPageProps> = ({
  id,
  pageDidMount,
  onClick,
  onDblClick,
  children,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <div
      id={id}
      className={styles.pageWrapper}
      ref={pageDidMount}
      onClick={onClick}
      onDoubleClick={onDblClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.bg}>
        <div className={styles.innerBg} />
        <div className={`${styles.left} ${styles.shd}`} />
        <div className={`${styles.right} ${styles.shd}`} />
      </div>
      <div className={styles.inlineContent}>{children()}</div>
    </div>
  );
};

const LiftedShadowPage: React.FC<SkinPageProps> = props => (
  <Page {...props} skin={LiftedShadowSkin} />
);

export default LiftedShadowPage;
